/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateSupplyEntryDto } from '../models/create-supply-entry-dto';
import { OrderRowSupplyEntry } from '../models/order-row-supply-entry';

/**
 * Supply Entries
 */
@Injectable({
  providedIn: 'root',
})
export class SupplyEntryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation createSupplyEntry
   */
  static readonly CreateSupplyEntryPath = '/api/mobile/supplyentry';

  /**
   * Crea una nuova fornitura per una riga d'ordine.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSupplyEntry()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSupplyEntry$Response(params: {
    context?: HttpContext;
    body: CreateSupplyEntryDto;
  }): Observable<StrictHttpResponse<OrderRowSupplyEntry>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      SupplyEntryService.CreateSupplyEntryPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<OrderRowSupplyEntry>;
        })
      );
  }

  /**
   * Crea una nuova fornitura per una riga d'ordine.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createSupplyEntry$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSupplyEntry(params: {
    context?: HttpContext;
    body: CreateSupplyEntryDto;
  }): Observable<OrderRowSupplyEntry> {
    return this.createSupplyEntry$Response(params).pipe(
      map(
        (r: StrictHttpResponse<OrderRowSupplyEntry>) =>
          r.body as OrderRowSupplyEntry
      )
    );
  }

  /**
   * Path part for operation deleteSupplyEntry
   */
  static readonly DeleteSupplyEntryPath = '/api/mobile/supplyentry/{id}';

  /**
   * Elimina una fornitura esistente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSupplyEntry()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSupplyEntry$Response(params: {
    /**
     * ID della fornitura da eliminare
     */
    id: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      SupplyEntryService.DeleteSupplyEntryPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: undefined,
          }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * Elimina una fornitura esistente.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteSupplyEntry$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSupplyEntry(params: {
    /**
     * ID della fornitura da eliminare
     */
    id: number;
    context?: HttpContext;
  }): Observable<void> {
    return this.deleteSupplyEntry$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }
}
